"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingIndicator = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var core_1 = require("@material-ui/core");
var styles_1 = __importDefault(require("./styles"));
exports.LoadingIndicator = react_1.default.memo(function (_a) {
    var _b = _a.loading, loading = _b === void 0 ? false : _b, children = _a.children, size = _a.size, fullscreen = _a.fullscreen, rest = __rest(_a, ["loading", "children", "size", "fullscreen"]);
    var classes = (0, styles_1.default)({ fullscreen: fullscreen });
    var Innards = loading ? ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({}, rest, { "aria-live": "polite", "aria-busy": loading }, { children: (0, jsx_runtime_1.jsx)(core_1.Box, __assign({ className: classes.loader }, { children: (0, jsx_runtime_1.jsx)(core_1.CircularProgress, { "data-testid": "circular-progress", size: size }) })) }))) : (
    // TODO: fix typing issue that prevents us from fixing a useless fragment
    // eslint-disable-next-line react/jsx-no-useless-fragment
    (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }));
    return fullscreen && loading ? react_dom_1.default.createPortal(Innards, document.body) : Innards;
});
exports.LoadingIndicator.displayName = 'LoadingIndicator';
